import ApiService from "services/ApiService";

export const getComponentsByProject = async (projectId) => {
    const res = await ApiService.get(`/component/project/${projectId}`);
    return res;
};

export const createComponent = async ({ project_id, value }) => {
    const res = await ApiService.post(`/component/project`, { project_id, value });
    return res;
};

export const findComponentByValue = async (projectId, value) => {
    const res = await ApiService.get(`/component/project/${projectId}/search?value=${value}`);
    return res;
};

export const getComponentsForTestCase = async (testCaseId) => {
    const res = await ApiService.get(`/component/test-cases/${testCaseId}`);
    return res;
};

export const assignComponentToTestCase = async (testCaseId, componentId) => {
    const res = await ApiService.post(`/component/test-cases/${testCaseId}`, {
        component_id: componentId,
    });
    return res;
};

export const removeComponentFromTestCase = async (testCaseId, componentId) => {
    const res = await ApiService.delete(`/component/test-cases/${testCaseId}/${componentId}`);
    return res;
};
